import type { Ref } from 'vue'
import { useWebSocketStore } from '@autobid/nuxt-pinia-store/store/useWebSocketStore'
import { auctionCarsQueryKey } from '@autobid/ui/composables/car/data/useAuctionCars'
import { AUCTION_CARS_SOCKET_CALLBACK } from '@autobid/ui/composables/car/sockets/useAuctionCarsSocket'
import { randomDebounce } from '@autobid/ui/utils/randomDebounce'
import { useQueryClient } from '@tanstack/vue-query'

export function useAuctionCarsItemPublish() {
  const { startListen } = useWebSocketStore()
  const queryClient = useQueryClient()

  const itemPublishDebounce = useState(
    'auction-cars-item-publish-debounce',
    () => ({}),
  ) as Ref<Record<number, NodeJS.Timeout>>

  const itemPublish = () => {
    startListen({
      eventName: 'premium.ITEM_PUBLISH',
      callbackName: AUCTION_CARS_SOCKET_CALLBACK,
      callback: (event) => {
        const { auctionId } = event.context
        clearTimeout(itemPublishDebounce.value[auctionId])

        itemPublishDebounce.value[auctionId] = randomDebounce(
          1000,
          3000,
          () => {
            const queryKey = auctionCarsQueryKey.byAuctionId(auctionId)
            queryClient.invalidateQueries(queryKey)
          },
        )
      },
    })
  }

  return { itemPublish }
}
